import { render, staticRenderFns } from "./BillRowsPerPageSelector.vue?vue&type=template&id=58f85d74&scoped=true"
import script from "./BillRowsPerPageSelector.vue?vue&type=script&lang=js"
export * from "./BillRowsPerPageSelector.vue?vue&type=script&lang=js"
import style0 from "./BillRowsPerPageSelector.vue?vue&type=style&index=0&id=58f85d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f85d74",
  null
  
)

export default component.exports